import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

// extra module added for header footer and common loading icon...
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SimplebarAngularModule } from 'simplebar-angular';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxSpinnerModule } from "ngx-spinner";
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ToastrModule } from 'ngx-toastr';
import { MatToolbarModule } from '@angular/material/toolbar';

// three component loded initially..
import { AppComponent } from './app.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { HeaderComponent } from '../app/components/header/header.component';
import { LeftMenuComponent } from './components/left-menu/left-menu.component';
import { NotificationComponent } from '../app/components/notification/notification.component';
import { FooterComponent } from './components/footer/footer.component';

//translation module added
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from "ngx-translate-multi-http-loader";

// feature modules (lazy loading)..
import { AuthModule } from './auth/auth.module';
import { HomeModule } from './components/dashboard/home/home.module';
import { MastersModule } from './components/masters/masters.module';
import { GeneralContractorModule } from './components/pre-contract/general-contractor/general-contractor.module';
import { ProjectModule } from './components/pre-contract/project/project.module';
import { SupplyModule } from './components/pre-contract/supply/supply.module';
import { RequisitionModule } from './components/pre-contract/requisition/requisition.module';
import { SubContractorModule } from './components/pre-contract/sub-contractor/sub-contractor.module';
import { BulkNotificationModule } from './components/bulk-notification/bulk-notification.module';
import { UsersModule } from '../app/components/users/users.module';
import { ProfileModule } from '../app/components/profile/profile.module';
import { ReportModule } from '../app/components/reports/report.module';
//user validation
import { HttpErrorInterceptorService } from '../app/common-services/http-error-interceptor.service';
import { AuthGuardGuard } from '../app/auth/auth-guard.guard';
import { analyticsRoutingModule } from './components/analytics/analytics-routing';
import { AnalyticsModule } from './components/analytics/analytics.module';
import { AdministrationModule } from './components/Administration/administration.module';
import { ImgPreviewComponent } from './common-components/img-preview/img-preview.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CompanyInterceptor } from './common-services/companyInterceptor.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { AppInitService } from './common-services/app-init.service';
import { SharedModule } from './common-modules/shared.module';
import { AccessDeniedComponent } from './common-components/access-denied/access-denied.component';
import { ScheduledMaintenanceComponent } from './common-components/scheduled-maintenance/scheduled-maintenance.component';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new MultiTranslateHttpLoader(http, [
		{ prefix: "../assets/translations/", suffix: ".json" },
	]);
}


import { MatPaginatorIntl } from '@angular/material/paginator';
import { CustomMatPaginatorIntlService } from './common-services/custom-mat-paginator-intl.service';

import { ReadOnlyHttpInterceptor } from './common-services/read-only-http.interceptor';
import { AppReadOnlyDialogService } from './common-services/read-only-dialog.service';

function initializeApp(appInitService: AppInitService): () => Promise<void> {
	return () => appInitService.init();
}

@NgModule({
	declarations: [
		AppComponent,
		DashboardComponent,
		HeaderComponent,
		LeftMenuComponent,
		NotificationComponent,
		FooterComponent,
		ImgPreviewComponent,
		AccessDeniedComponent,
		ScheduledMaintenanceComponent

	],
	imports: [

		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		SharedModule,
		SimplebarAngularModule,
		FlexLayoutModule,
		MatMenuModule,
		MatButtonModule,
		MatIconModule,
		MatExpansionModule,
		MatTooltipModule,
		MatBadgeModule,
		ScrollingModule,
		NgxSpinnerModule,
		HttpClientModule,
		FormsModule,
		ReactiveFormsModule,
		MatBadgeModule,
		MatDialogModule,
		MatToolbarModule,
		ToastrModule.forRoot({
			preventDuplicates: true,       // This stops identical toast messages from stacking
			countDuplicates: true,         // Adds a "2x", "3x" badge instead of opening a new toast
			resetTimeoutOnDuplicate: true  // Extends the toast visibility time when a duplicate triggers
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),

		ReactiveFormsModule,
		analyticsRoutingModule,
		AdministrationModule,
		MatFormFieldModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatInputModule,




	],
	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: ReadOnlyHttpInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptorService, multi: true },
		AuthGuardGuard,
		{ provide: HTTP_INTERCEPTORS, useClass: CompanyInterceptor, multi: true },
		DatePipe,
		{ provide: APP_INITIALIZER, useFactory: initializeApp, deps: [AppInitService], multi: true },
		{ provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntlService },
		{ provide: MatDialog, useClass: AppReadOnlyDialogService }
	],
	bootstrap: [AppComponent],
	entryComponents: [
		// PopUpComponent
	]
})
export class AppModule { }

